<template>

    <PublicWidgetsWrapper ref="wrapper">
      
      <div class="flex flex-row items-top justify-between">
        <h1 class="text-lg font-semibold mb-3">Fetching Results</h1>
      </div>
  
      <hr class="border-b border-gray-100 mb-3">
  
      <v-container v-if="fetchingStats">
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-skeleton-loader
              type="article"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
  
      <div v-if="!fetchingSearches">
  
        <div class="dashboard-box mb-6">
          <v-card
            class=""
            tile
          >
            <div class="lf-search-form dashboard">
              <div class="flex flex-row flex-wrap">
                <div class="w-full lg:w-1/2">
                  <v-text-field
                    label="Search"
                    prepend-inner-icon="mdi-magnify"
                    v-model="search_keyword"
                    outlined
                    dense
                    hide-details
                    style="margin-top: 5px;"
                  ></v-text-field>
  
                  <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-2 ml-3 mr-3" />
                </div>
  
                <div class="w-full lg:w-1/2 -ml-6">
                  <div class="lf-search-location-box">
                    <v-combobox
                        label="Location"
                        prepend-inner-icon="mdi-map-marker-outline"
                        v-model="autocompleteLocationModel"
                        :items="locationFoundItems"
                        :search-input.sync="locationSearchText"
                        item-text="value"
                        item-value="id"
                        hide-no-data
                        return-object
                        outlined
                        dense
                        hide-details
                        @change="selectPlace()"
                        style="height: 40px; border: 0px; margin-top: 5px; margin-bottom: 5px;"
                      >
                    </v-combobox>
  
                    <hr v-if="$vuetify.breakpoint.xs" class="mt-2 mb-4 ml-3 -mr-3" />
                  </div>
                </div>
  
                <div class="lf-search-form-search-type">
                    <v-radio-group
                      class="mt-3"
                      row
                      v-model="search_type"
                      >
                          <v-radio
                          label="Local"
                          :value="'local'"
                          on-icon="mdi-circle"
                          off-icon="mdi-circle-outline"
                          :ripple="false"
                          ></v-radio>
                          <v-tooltip bottom color="#434C5E">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                <v-radio
                                  label="Multi-Snipe"
                                  :value="'in_depth'"
                                  on-icon="mdi-circle"
                                  off-icon="mdi-circle-outline"
                                  :ripple="false"

                                ></v-radio>
                              </span>
                            </template>
                            <span>
                              <strong>Multi-Snipe:</strong>
                              <br />
                              Multi-Snipe search will look up all the zip codes of the city you selected, and then does a search for every keyword in zip code combination.
                              <br /><br />
                              <strong>WARNING:</strong>
                              <br />
                              This can use a lot of Google API credits. If we find 10 zip codes -  we do 10 searches vs. 1. Thats 10 times the API requests.
                              <br />
                              Example: If a Local Search brings in 60 results thats 3 api queries to get the data, and then another 60 to pull the phone number for every listing. 
                              <br />
                              Thats 120 credits. Now if we used the Multi-Snipe feature - ad there were 10 zip codes - we would repeat the process 10 times. That means we'd use 10x the API requests.
                              <br /><br />
                              <strong>Cost breakdown:</strong>
                              <br />
                              - Get Keyword & Location: $0.032
                              <br />
                              - Main Search: $0.032
                              <br />
                              - Business Detail: $0.18 for 60 results
                            </span>
                          </v-tooltip>
                      </v-radio-group>
                </div>
  
                <div class="lf-search-form-submit-button" @click="addSearch()" style="right: 0px;">
                  <i v-if="savingSearch" class="fa fa-spin fa-spinner"></i>
                  <i v-else class="mdi mdi-magnify"></i>
                </div>
              </div>
            </div>
          </v-card>
        </div>
  
        <div v-if="add_search_error" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
            <div v-html="add_search_error"></div>
        </div>
  
        <div class="flex flex-row flex-wrap">
          <div :class="'w-full lg:w-2/3' + (($vuetify.breakpoint.xs) ? '' : ' pr-5')">
            <div class="text-gray-600 text-md text-bold mb-4">New Searches</div>
  
            <div v-if="new_searches === null">
              <v-skeleton-loader
                type="article"
                class="mb-4"
              ></v-skeleton-loader>
  
              <v-skeleton-loader
                type="article"
                class="mb-4"
              ></v-skeleton-loader>
  
              <v-skeleton-loader
                type="article"
              ></v-skeleton-loader>
            </div>
  
            <div v-else v-for="search in new_searches" :key="search.id" class="dashboard-box mb-4">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-2" style="position: relative;">
  
                  <div style="position: absolute; top: -5px; right: -3px;">
                    <v-tooltip v-if="dateDifference(search.created_at) > 20" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i class="fa fa-clock text-red-600" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>Your search is taking longer than expected. <br />Please contact us via chat.</span>
                    </v-tooltip>
  
                    <v-tooltip v-if="dateDifference(search.created_at) < 10" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i class="fa fa-clock text-green-600" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>Your job is processing and should be completed between 5 to 10 minutes.</span>
                    </v-tooltip>
  
                    <v-tooltip v-if="dateDifference(search.created_at) > 10 && dateDifference(search.created_at) < 20" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <i class="fa fa-clock text-orange-600" v-bind="attrs" v-on="on"></i>
                      </template>
                      <span>This is a larger job and will little longer, but it should be completed in less than 20 minutes.</span>
                    </v-tooltip>
                  </div>
  
                  <div style="word-break: break-word;">
  
                    <div class="float-right">
                      <span style="font-size: 12px; color: #757B89;">
                        {{ formatDate(search.created_at) }}
                      </span>
                      <div class="pt-4 text-right">
                        <router-link :to="'/public-widgets/search-details/' + search.id">
                          <span style="color: #3A9BDB; font-size: 12px; opacity: 0.5; font-weight: bold;">View Results</span>
                        </router-link>
                      </div>
                    </div>
  
                    <strong>
                      <span class="text-lg">{{ search.keyword }}</span>  
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="orange lighten-5"
                        text-color="orange lighten-1"
                        v-if="search.status == 'pending'"
                      >
                        pending
                      </v-chip>
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        v-if="search.status == 'completed'"
                      >
                        completed
                      </v-chip>
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="blue lighten-5"
                        text-color="blue lighten-1"
                      >
                      {{ search.search_results_count }} leads
                      </v-chip>
                    </strong>
  
                    <div class="text-gray-600 pt-3" style="font-size: 12px;">
                      <i class="mdi mdi-map-marker-outline mr-1" style="font-size: 16px;"></i> {{ search.location }}
                    </div>
                  </div>
                  <div style="clear: both;"></div>
                  <v-progress-linear
                    class="mt-3"
                    color="blue lighten-2"
                    buffer-value="0"
                    stream
                    :value="search.percentage_completed"
                    v-if="search.status == 'pending'"
                  ></v-progress-linear>
                </div>
              </v-card>
            </div>
  
            <div v-if="new_searches !== null && new_searches.length == 0">
              <div class="dashboard-box">
                <v-card
                  class="pa-2"
                  tile
                >
                  <div class="p-3">
  
                    <br /><br /><br /><br /><br /><br /><br />
  
                    <div class="dashboard-box-iconsquare">
                      <div class="dashboard-box-icon-background blue"></div>
                      <div class="dashboard-box-icon">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1117_1999)">
                            <path d="M23.9527 23.9711C24.1618 23.7619 24.5009 23.7619 24.71 23.9711L31.0559 30.3169C31.265 30.526 31.265 30.8651 31.0559 31.0742C30.8467 31.2833 30.5077 31.2833 30.2985 31.0742L23.9527 24.7284C23.7436 24.5193 23.7436 24.1802 23.9527 23.9711Z" fill="#3EBB80" stroke="#3A9BDB"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3294 17.6647C27.3294 12.327 23.0024 8.00001 17.6647 8.00001C12.327 8.00001 8 12.327 8 17.6647C8 23.0024 12.327 27.3294 17.6647 27.3294C23.0024 27.3294 27.3294 23.0024 27.3294 17.6647ZM25.2584 17.6647C25.2584 13.4708 21.8586 10.071 17.6647 10.071C13.4708 10.071 10.071 13.4708 10.071 17.6647C10.071 21.8586 13.4708 25.2584 17.6647 25.2584C21.8586 25.2584 25.2584 21.8586 25.2584 17.6647Z" fill="#3A9BDB"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_1117_1999">
                              <rect width="40" height="40" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
  
                    <div style="text-align: center;">
                      <div class="pt-2 pb-2">
                        <strong>No New Searches</strong>
                      </div>
  
                      <div class="text-sm mb-4 text-gray-600">
                        Create another search above.
                      </div>
                    </div>
                    
                    <br /><br /><br /><br /><br /><br /><br /><br />
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <div :class="'w-full lg:w-1/3' + (($vuetify.breakpoint.xs) ? 'mt-5' : ' pl-5')">
            <div class="text-gray-600 text-md text-bold mb-4">Recent Searches ({{ ((recent_searches) ? recent_searches.length : 0) }})</div>
  
            <div v-if="recent_searches === null">
              <v-skeleton-loader
                type="article"
                class="mb-4"
              ></v-skeleton-loader>
  
              <v-skeleton-loader
                type="article"
                class="mb-4"
              ></v-skeleton-loader>
  
              <v-skeleton-loader
                type="article"
              ></v-skeleton-loader>
            </div>
  
            <div v-else v-for="search in recent_searches" :key="search.id" class="dashboard-box mb-4">
              <v-card
                class="pa-2"
                tile
              >
                <div class="p-2">
                  <div style="word-break: break-word;">
  
                    <div class="float-right">
                      <span style="font-size: 12px; color: #757B89;">
                        {{ formatDate(search.created_at) }}
                      </span>
                      <div class="pt-4 text-right">
                        <router-link :to="'/public-widgets/search-details/' + search.id">
                          <span style="color: #3A9BDB; opacity: 0.7; font-size: 12px; font-weight: bold;">View Results</span>
                        </router-link>
                      </div>
                    </div>
  
                    <strong>
                      <span class="text-lg">{{ search.keyword }}</span>  
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="orange lighten-5"
                        text-color="orange lighten-1"
                        v-if="search.status == 'pending'"
                      >
                        pending
                      </v-chip>
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        v-if="search.status == 'completed'"
                      >
                        completed
                      </v-chip>
  
                      <v-chip
                        class="ml-3 -mt-2"
                        small
                        color="blue lighten-5"
                        text-color="blue lighten-1"
                      >
                      {{ search.search_results_count }} leads
                      </v-chip>
                    </strong>
  
                    <div class="text-gray-600 pt-3" style="font-size: 12px;">
                      <i class="mdi mdi-map-marker-outline mr-1" style="font-size: 16px;"></i> {{ search.location }}
                    </div>
                    <div class="mobile-only mt-1" style="font-size: 12px; color: #757B89;">
                      <i class="fa fa-calendar"></i> {{ formatDate(search.created_at) }}
                    </div>
                  </div>
                  <div style="clear: both;"></div>
                  <v-progress-linear
                    class="mt-3"
                    color="blue lighten-2"
                    buffer-value="0"
                    stream
                    :value="search.percentage_completed"
                    v-if="search.status == 'pending'"
                  ></v-progress-linear>
                </div>
              </v-card>
            </div>
  
            <div v-if="recent_searches !== null && recent_searches.length == 0">
              <div class="dashboard-box">
                <v-card
                  class="pa-2"
                  tile
                >
                  <div class="p-4 text-center text-gray-600 text-sm">
                    No searches found.
                  </div>
                </v-card>
              </div>
            </div>
          </div>
        </div>
  
        <br clear="all" />
  
      </div>
  
    </PublicWidgetsWrapper>
  
  </template>
  
  <script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import $ from 'jquery'
  import moment from 'moment'
  import { GetSuggestions } from '@/utils/PlaceUtils'
  import PublicWidgetsWrapper from '@/views/panel/PublicWidgets/Wrapper.vue'

  export default {
    components: {
        PublicWidgetsWrapper
    },
    data () {
      return {
        fetchingStats: false,
        dashboard_stats: null,
  
        search_keyword: null,
        add_search_error: null,
        
        autocompleteLocationModel: null,
        locationSearchText: null,
        locationEntries: [],
  
        search_type: 'local',
  
        savingSearch: false,
  
        search_location: null,
  
        searches_interval: null,
  
        new_searches: null,
  
        new_searches: null,
        recent_searches: null,
        ip_count:0
      }
    },
    computed: {
      ...mapState({
        searches: state => state.searches.searches,
        fetchingSearches: state => state.searches.fetchingSearches,
      }),
      locationFoundItems () {
        return this.locationEntries
      }
    },
    methods: {
      formatDate: function(date) {
        return moment(String(date)).fromNow()
      },
  
      dateDifference: function(date) {
        let end = moment();
        var duration = end.diff(moment(date))/1000/60;
  
        return duration;
      },
  
      async getSearches() {
        let url = `${process.env.VUE_APP_API_ENDPOINT}/dashboard-searches`;
  
        let response = await axios.get(url, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          }
        })
  
        this.new_searches = response.data.new_searches;
        this.recent_searches = response.data.recent_searches;
        this.ip_count = response.data.ip_count;
      },

      showLimitReached() {
        let noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
            <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -280px;">
                <h1 style="color: #FFFFFF; font-size: 30px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                    You have reached your limit. Upgrade your account to get unlimited searches.</p>

                <br />

                <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
            </div>
        </div>`;

        if (this.$vuetify.breakpoint.xs) {
            noAccessHtml = `<div id="no-access-html" style="background: rgba(0, 0, 0, 0.7); position: fixed; width: 100%; height: 100%; left: 0; right: 0; top: 0; bottom:0; color: #FFFFFF; text-align: center; z-index: 999;" onclick="document.getElementById('no-access-html').style.display = 'none';">
              <div style="    position: fixed; top: 50%; margin-top: -150px; left: 50%; margin-left: -129px;">
                      <h1 style="color: #FFFFFF; font-size: 24px; font-weight: bold; padding-bottom: 10px;">Search Limit Reached</h1>

                      <p style="font-weight: bold; font-size: 13px; line-height: 22px;">
                          You have reached your limit. <br />Upgrade your account to get<br /> unlimited searches.</p>

                      <br />

                      <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer" style="width: 140px; margin: auto; background-color: #3A9BDB; border-radius: 5px; font-size: 14px; padding: 8px; font-weight: bold; cursor: pointer;" onclick="window.location = '/pricing';">SELECT PLAN</div>
                  </div>
              </div>`;
        }

        parent.postMessage({
            event_id: 'postHtml',
            data: {
                newHtml: noAccessHtml
            }
        },"*");  //  `*` on any domain
      },
      getCookie: function(name) {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
          return null;
      },
      setCookie: function(name, value, days) {
          let date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); 
          document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
      },
      addSearch: async function() {
        if (this.new_searches.length + this.recent_searches.length >= 3) {
            // this.showLimitReached();
            // return;
        }
        if (this.ip_count >= 5) {
            this.showLimitReached();
            return;
        }
        this.add_search_error = null
  
        if (!this.search_keyword) {
          this.add_search_error = "Please enter keyword.";
          return;
        }
  
        if (!this.search_location) {
          this.add_search_error = "Please enter location.";
          return;
        }
          

        let searchCount = parseInt(this.getCookie('searchCount')) || 0;

        if (searchCount >= 5) {
            this.add_search_error = "Search limit reached (5 searches).";
            this.showLimitReached();
            return;
        }
        this.savingSearch = true;
  
        let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/searches/add-search', {
          search_keyword: this.search_keyword,
          search_location: this.search_location,
          search_type: this.search_type
        } , {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          },
        })
        searchCount++;
        this.setCookie('searchCount', searchCount, 7);

        this.$store.dispatch('searches/fetch', {
          page: 1,
          itemsPerPage: 10,
          force_token: localStorage.getItem("lfp-auth-user")
        })
  
        this.getSearches()
  
        this.savingSearch = false
        this.search_keyword = null
        this.search_location = null
        this.autocompleteLocationModel = null
      },
      getAddressObject(address_components) {
  
        var ShouldBeComponent = {
          street_number: ["street_number"],
          zip: ["postal_code"],
          address: ["street_address", "route"],
          state: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5"
          ],
          city: [
            "locality",
            "colloquial_area",
            "political",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
          ],
          country: ["country"]
        };
  
        var address = {
          street_number: "",
          zip: "",
          address: "",
          state: "",
          city: "",
          country: ""
        };
        address_components.forEach(component => {
          for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
              if (shouldBe === "country") {
                address[shouldBe] = component.short_name;
              } else {
                address[shouldBe] = component.long_name;
              }
            }
          }
        });
        return address;
      },
      filterPlaces (item, queryText, itemText) {
        return true
      },
      selectPlace() {
        let that = this
  
        $.get("https://maps.googleapis.com/maps/api/geocode/json?place_id=" + this.autocompleteLocationModel.id + "&fields=name,rating,formatted_phone_number&key=AIzaSyAtBA0jGEnrTzfQlETQOECnG5FdXFBvycU", function(response) {
          that.company_name = that.autocompleteLocationModel.value.split(",")[0];
  
          let address = that.getAddressObject(response.results[0].address_components);
          let search_location = {};
          search_location.street_number = address.street_number;
          search_location.address = address.address;
          search_location.city = address.city;
          search_location.state = address.state;
          search_location.zip = address.zip;
          search_location.country = address.country;
  
          search_location.lat = response.results[0].geometry.location.lat;
          search_location.lng = response.results[0].geometry.location.lng;
          search_location.place_id = response.results[0].place_id;
  
          that.search_location = search_location;
        });
      },
  
      async getDashboardStats() {
        this.fetchingStats = true;
        let url = `${process.env.VUE_APP_API_ENDPOINT}/inbox/get-dashboard-stats`;
  
        let response = await axios.get(url, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("lfp-auth-user")
          }
        })
  
        this.fetchingStats = false;
  
        this.dashboard_stats = response.data.stats;
      }
    },
    created() {
      this.$store.state.searches.fetchingSearches = true
      this.$store.dispatch('searches/fetch', {
        page: 1,
        itemsPerPage: 10,
        force_token: localStorage.getItem("lfp-auth-user")
      })
  
      let self = this;
      this.searches_interval = setInterval(function() {
        self.$store.dispatch('searches/fetch', {
          page: 1,
          itemsPerPage: 10,
          force_token: localStorage.getItem("lfp-auth-user")
        })
        self.getSearches();
      }, 5000);
  
      self.getSearches();
  
      self.getDashboardStats();
    },
    beforeDestroy() {
      clearInterval(this.searches_interval);
      this.searches_interval = null
    },
    watch: {
      locationSearchText (newVal) {
        var that = this;
  
        // If less than 3 chars typed, do not search
        if (!newVal || newVal.length <= 3) return
  
        // Call the method from the previous section here
        GetSuggestions(newVal)
          .then(function (res) {
            that.locationEntries = res;
          })
          .catch(function () {
            that.business = false;
            that.step = 1;
          })
      }
    }
  }
  </script>